import { createApp } from "vue";
import App from "./App.vue";
import { createPinia } from "pinia";
import VueGoogleMaps from "@fawmi/vue-google-maps";
const app = createApp(App);

app.use(createPinia());
app.use(VueGoogleMaps, {
  load: {
    key: window.drupalSettings.google_api_key,
    libraries: "places",
  },
});
const mapToAttach = ["agents", "workshops"];
import { useContentStore } from "./store/content";
Promise.all(
  mapToAttach.map(async (mapType) => {
    const mapWrapper = document.querySelector(`.map--${mapType}`);
    if (!mapWrapper) return;
    if (!mapWrapper.querySelector(`#map--${mapType}`)) {
      useContentStore().contentType = mapType;
      const div = document.createElement("div");
      div.id = `map--${mapType}`;
      mapWrapper.appendChild(div);
      await app.mount(`#map--${mapType}`);
    }
  })
);
